module.exports = __webpack_public_path__ + "img/chevron-down.6d3d9b21.svg";